import GetWithProgress from "partners/utils/get_with_progress"

import PropTypes from "prop-types"

// Triggers and fields are moved to use Vanilla JS instead of jQuery.
// We were using delegate. It creates event listeners to each object and one observer for new DOMs.
// New approach to reduce memory is create only one event listener for clicks and check if it's the desired event target.
export default function StepFieldsActions({ step }) {
  const clicksObserver =
    step === "trigger" ? TriggerClicksObserver : ActionClicksObserver

  document.addEventListener("click", clicksObserver)

  const removeListeners = () =>
    document.removeEventListener("click", clicksObserver)

  window.addEventListener("turbolinks:before-visit", removeListeners, {
    once: true,
  })
  window.addEventListener("beforeunload", removeListeners, { once: true })
}

StepFieldsActions.propTypes = {
  step: PropTypes.oneOf(["action", "trigger"]),
}

// Actions looks for:
//  - New action field
//  - Edit action field
//  - Cancel new action field form
const ActionClicksObserver = event => {
  const el = event.target
  if (!el.dataset.loadFormAsync) return

  event.preventDefault()

  const classes = el.classList
  if (classes.contains("add-field") || el.matches("button[data-href]")) {
    loadEditForm(el)
  } else if (el.matches("img[title='Edit field']")) {
    // Edit field icon is composed by button+img. Avoiding use bubbling event to not need to check for all clicks.
    // When image from button is clicked, we move for the parent node.
    loadEditForm(el.parentNode)
  } else if (el.matches("a[data-action='cancel-form']")) {
    const fieldEdit = document.querySelector(".field-edit")
    fieldEdit.parentNode.removeChild(fieldEdit)
    showElements([".field-list li", ".action-inputs .add-field"])
  }
}

// Actions looks for:
//  - New trigger field
//  - New ingredient
//  - Cancel new trigger field and ingredient form
//  - Edit trigger field
const TriggerClicksObserver = event => {
  const el = event.target
  if (!el.dataset.loadFormAsync) return

  event.preventDefault()

  const classes = el.classList
  if (
    classes.contains("add-ingredient") ||
    classes.contains("add-field") ||
    el.matches("button[data-href]")
  ) {
    loadEditForm(el)
  } else if (
    el.matches("img[title='Edit field']") ||
    el.matches("img[title='Edit ingredient']")
  ) {
    // Edit field icon is composed by button+img. Avoiding use bubbling event to not need to check for all clicks.
    // When image from button is clicked, we move for the parent node.
    loadEditForm(el.parentNode)
  } else if (el.matches("a[data-action='cancel-form']")) {
    if (el.dataset.loadFormAsync === "ingredients") {
      const ingredientEdit = document.querySelector(".ingredient-edit")
      ingredientEdit.parentNode.removeChild(ingredientEdit)
      showElements([".ingredient-list li", ".trigger-outputs .add-ingredient"])
    } else if (el.dataset.loadFormAsync === "trigger-fields") {
      const fieldEdit = document.querySelector(".field-edit")
      fieldEdit.parentNode.removeChild(fieldEdit)
      showElements([".field-list li", ".user-inputs .add-field"])
    }
  }
}

// Use loading class to avoid multiples load from same page.
const loadEditForm = el => {
  if (!el.classList.contains("loading")) {
    el.classList.add("loading")
    GetWithProgress(el.dataset.href).finally(() =>
      el.classList.remove("loading")
    )
  }
}

const showElements = elements => {
  document.querySelectorAll(elements).forEach(el => {
    el.style.display = ""
  })
}
